import type { FunctionComponent } from 'react';
import { useEffect, useState } from 'react';

import { useFeatureFlag } from '@trello/feature-flag-client';
import { addIdleTask, clearIdleTask } from '@trello/idle-task-scheduler';

import type { BoardDisplayAdsContainerProps } from './BoardDisplayAdsContainer';
import { LazyBoardDisplayAdsContainer } from './LazyBoardDisplayAdsContainer';

export const DeferredBoardDisplayAdsContainer: FunctionComponent<
  BoardDisplayAdsContainerProps
> = (props) => {
  const [renderAdComponent, setRenderAdComponent] = useState<boolean>(false);
  const deferralTime = useFeatureFlag<number>(
    'phoenix.web.display-ads-deferral-time',
    5000,
  );

  useEffect(() => {
    const taskId = addIdleTask(() => {
      setRenderAdComponent(true);
    }, deferralTime);

    return () => {
      clearIdleTask(taskId);
    };
  }, [deferralTime]);

  if (renderAdComponent) {
    return <LazyBoardDisplayAdsContainer {...props} />;
  }

  return null;
};
